import { useMemo } from 'react';
import type { ComponentType } from 'react';
import type { ColDef, ICellRendererParams } from 'ag-grid-community';
import type { IAppointment } from '../../../models/appointment/AppointmentModel';

export function useAppointmentsColumnDefs(
  actionCellRenderer: ComponentType<ICellRendererParams<IAppointment>>
): ColDef<IAppointment>[] {
  return useMemo<ColDef<IAppointment>[]>(
    () => [
      {
        headerName: 'İşlemler',
        cellRenderer: actionCellRenderer,
        width: 120,
        sortable: false,
        filter: false,
        pinned: 'left',
      },
      {
        field: 'personName',
        headerName: 'Kişi Adı',
        flex: 1,
        minWidth: 150,
        filter: true,
        sortable: true,
      },
      {
        field: 'requestNumber',
        headerName: 'Etiket Numarası',
        flex: 1,
        minWidth: 150,
        filter: true,
        sortable: true,
      },
      {
        field: 'hospitalName',
        headerName: 'Hastane',
        flex: 1,
        minWidth: 150,
        filter: true,
        sortable: true,
      },
      {
        field: 'appointmentDate',
        headerName: 'Randevu Tarihi',
        flex: 1,
        minWidth: 150,
        filter: true,
        sortable: true,
        valueFormatter: params => {
          if (!params.value) return '';
          return new Date(params.value).toLocaleDateString('tr-TR');
        },
      },
      {
        field: 'appointmentStartTime',
        headerName: 'Başlangıç',
        flex: 1,
        minWidth: 90,
        filter: true,
        sortable: true,
      },
      {
        field: 'appointmentEndTime',
        headerName: 'Bitiş',
        flex: 1,
        minWidth: 90,
        filter: true,
        sortable: true,
      },
      {
        field: 'userName',
        headerName: 'Kullanıcı',
        flex: 1,
        minWidth: 120,
        filter: true,
        sortable: true,
        valueFormatter: params => params.value || params.data?.userId || '-',
      },
      {
        field: 'deviceList',
        headerName: 'Cihaz Listesi',
        flex: 1,
        minWidth: 150,
        filter: true,
        sortable: true,
      },
    ],
    [actionCellRenderer]
  );
}

export function useAppointmentsDefaultColDef(): ColDef<IAppointment> {
  return useMemo(
    () => ({
      resizable: true,
      sortable: true,
      filter: true,
    }),
    []
  );
}

